import Big from 'big.js';
import * as models from '../models';
import { MaybePromise } from '../promise';
import * as hyejoo from './hyejoo';

export const {
    getAll: GetStockItems,
    get: GetStockItem,
} = hyejoo.Getters('/stock-items', (resp: hyejoo.StockItems) => resp.stockItems);

export function GetStockItemPrice(stockItem: models.StockItem, quantity: number): Big
export function GetStockItemPrice(stockItemID: string, quantity: number): Promise<Big>
export function GetStockItemPrice(stockItem: models.StockItem | string, quantity: number): MaybePromise<Big> {
    if (typeof stockItem === 'string') {
        return GetStockItem(stockItem, { data: 'price,quantityPricing' }).then(stockItem => {
            if (!stockItem) {
                return new Big('0');
            }

            return GetStockItemPrice(stockItem, quantity);
        });
    }

    if (stockItem.quantityPricing && Object.keys(stockItem.quantityPricing).length) {
        // convert to array so we can sort it more easily
        const quantityPricing: { quantity: number; price: string }[] = [];
        for (const [quantity, price] of Object.entries(stockItem.quantityPricing)) {
            quantityPricing.push({ quantity: parseInt(quantity, 10), price });
        }

        // sort the quantityPricing by quantity desc
        quantityPricing.sort((a, b) => b.quantity - a.quantity);

        // find the first quantityPricing where the quantity is less than or equal to the stockItem's quantity
        for (const qp of quantityPricing) {
            if (quantity >= qp.quantity) {
                return new Big(qp.price);
            }
        }
    }

    return new Big(stockItem.price ?? '0');
}